import { Box, makeStyles, useMediaQuery } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { get } from "lodash";
import React from "react";
import { Button, useListContext } from "react-admin";
import { Form } from "react-final-form";

const useStyles = makeStyles(
	(theme) => ({
		form: {
			marginTop: -theme.spacing(2),
			paddingTop: 0,
			display: "flex",
			alignItems: "flex-end",
			flexWrap: "wrap",
			minHeight: theme.spacing(10),
		},
		clearFix: { clear: "right" },
		button: {
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
		},
		wrapper: {
			width: "100%",
		},
		[theme.breakpoints.down("sm")]: {
			submit: {
				marginBottom: theme.spacing(2),
			},
		},
	}),
	{ name: "RaFilterForm" }
);

const Wrapper = ({ sm = false, children, spacerTop }) => {
	const classes = useStyles();
	return (
		<React.Fragment>
			{!sm && spacerTop && 1 == 0 && <Box mt={8} />}
			{!sm ? (
				<Box display="flex" flexWrap="wrap" alignItems="flex-end">
					{children}
				</Box>
			) : (
				<Box className={classes.wrapper}>{children}</Box>
			)}
		</React.Fragment>
	);
};

const FilterForm = ({ resource, children, spacerTop = true }) => {
	const classes = useStyles();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const {
		filterValues,
		setFilters,
		displayedFilters,
		loading,
	} = useListContext();

	if (
		!get(displayedFilters, "main") &&
		Object.keys(filterValues).length === 0
	) {
		return null;
	}

	const onSubmit = (values) => {
		if (Object.keys(values).length > 0) {
			setFilters(values);
		}
	};

	return (
		<div style={{ width: "100%" }}>
			<Form onSubmit={onSubmit} initialValues={filterValues}>
				{({ handleSubmit }) => (
					<form onSubmit={handleSubmit} className={classes.form}>
						<Wrapper sm={sm} spacerTop={spacerTop}>
							{React.Children.map(children, (field, index) =>
								React.isValidElement(field) ? (
									<Box component="span" mr={1} {...get(field, "props.box", {})}>
										{React.cloneElement(field, {
											key: get(field, "props.source", index),
											resource,
											variant: "outlined",
											...field.props,
										})}
									</Box>
								) : null
							)}
							<Box component="span" mr={2} mb={1}>
								<Button
									color="primary"
									type="submit"
									variant={!sm ? "text" : "contained"}
									label="ra.action.search"
									disabled={loading}
									size="small"
									className={classes.submit}
								>
									<SearchIcon />
								</Button>
							</Box>
						</Wrapper>
					</form>
				)}
			</Form>
		</div>
	);
};

export default FilterForm;
